import { Box } from '@mui/material';
import { ResursLoading } from '@resurs-internal/mui';

import { ButtonLoadingStyles, LoadingStyles } from './Spinner.styles';

type Props = {
    size: 'xs' | 'sm' | 'md' | 'lg' | 'xl' | 'xxl' | undefined;
    buttonLoadingStyles?: boolean;
};

const Spinner = ({ size, buttonLoadingStyles }: Props) => {
    return (
        <Box sx={buttonLoadingStyles ? ButtonLoadingStyles : LoadingStyles}>
            <ResursLoading size={size} aria-hidden />
        </Box>
    );
};

export default Spinner;
